import { render, staticRenderFns } from "./o-edit-resource.vue?vue&type=template&id=28a73b28&"
import script from "./o-edit-resource.vue?vue&type=script&lang=js&"
export * from "./o-edit-resource.vue?vue&type=script&lang=js&"
import style0 from "./o-edit-resource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports